import { render, staticRenderFns } from "./DownloadStudent.vue?vue&type=template&id=f0da0370&scoped=true&"
import script from "./DownloadStudent.vue?vue&type=script&lang=js&"
export * from "./DownloadStudent.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStudent.vue?vue&type=style&index=0&id=f0da0370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0da0370",
  null
  
)

export default component.exports